import { useEffect, useState } from 'react';
import Link from 'components/ui/Link';
import { formatAsShortDate } from 'utils/date';
import { useTranslation } from 'hooks/useTranslation';
import styles from './AuthorByLine.module.scss';
import type { PageAuthors } from 'types/Author';

type Props = {
  authorEntry?: PageAuthors;
  lastUpdated: string;
};

const AuthorByLine = ({ authorEntry, lastUpdated }: Props): JSX.Element => {
  const { t, locale } = useTranslation();
  const [date, setDate] = useState('');

  useEffect(() => {
    if (lastUpdated) {
      setDate(formatAsShortDate(lastUpdated, locale));
    }
  }, [lastUpdated]);

  return (
    <>
      {authorEntry && (
        <ul className={styles.list}>
          {authorEntry.author && (
            <li className={styles.listItem}>
              {t('blog.author.by')}{' '}
              <Link
                href={authorEntry.author.slug}
                className={styles.link}
                legacyBehavior={false}
              >
                {authorEntry.author.name}
              </Link>
            </li>
          )}
          {authorEntry.medicalAuthor && (
            <li className={styles.listItem}>
              {`${t('medicalReviewBy')} ${t('blog.author.by')} `}
              <Link
                href={authorEntry.medicalAuthor.slug}
                className={styles.link}
                legacyBehavior={false}
              >
                {authorEntry.medicalAuthor.name}
              </Link>
            </li>
          )}
          <li>
            {t('updated')}: {date}
          </li>
        </ul>
      )}
    </>
  );
};

export default AuthorByLine;
